import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useDispatch } from 'react-redux';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

import {
	useAssignMarketFabricCategoryByClientIdMutation,
	useRemoveMarketFabricCategoryByClientIdMutation
} from '@features/crm/brands/api/brandProfileApi';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchCategories, fetchDepartments, fetchFabricCategory } from '@services/commonService';

import { _getKey, capitalizeFirstLetter } from '@utils/Util';

import CommonImage from '@/components/CommonImage';

const ClientWiseDepartment = ({ onClose, clientId, selected = [] }) => {
	const [markets, setMarkets] = useState([]);
	const [categories, setCategories] = useState([]);
	const [fabricTypes, setFabricTypes] = useState([]);
	const [data, setData] = useState([]);
	const [assignMarketFabricCategoryByClientId] = useAssignMarketFabricCategoryByClientIdMutation();
	const [removeMarketFabricCategoryByClientId] = useRemoveMarketFabricCategoryByClientIdMutation();
	const [editableId, setEditableId] = useState(null);
	const dispatch = useDispatch();

	useEffect(() => {
		if (selected.length > 0) {
			let existingData = [];
			selected.forEach((item) => {
				existingData.push({
					uId: _getKey(),
					id: item?.mapId || null,
					markets: item?.productGroupId
						? { label: item.productGroupName, value: item.productGroupId }
						: [],
					categories:
						item?.categoryList?.map((category) => ({
							label: category.name,
							value: category.id
						})) || [],
					fabricTypes: item?.fabricType
						? {
								label: capitalizeFirstLetter(item.fabricType),
								value: item.fabricType
							}
						: []
				});
			});
			setData(existingData);
		} else {
			setData([{ uId: _getKey(), markets: [], categories: [], fabricTypes: [] }]);
		}
	}, [clientId]);

	useEffect(() => {
		if (data.length > 0) {
			let lastItem = data[data.length - 1];
			if (lastItem.markets && lastItem.categories.length > 0 && lastItem.fabricTypes) {
				setData((prev) => [
					...prev,
					{ uId: _getKey(), markets: [], categories: [], fabricTypes: [] }
				]);
			}
		}
	}, [data]);

	useEffect(() => {
		(async () => {
			const marketData = await fetchDepartments();
			const categoriesData = await fetchCategories();
			const fabricType = await fetchFabricCategory();
			if (marketData?.length > 0) {
				setMarkets(marketData?.map((item) => ({ label: item.name, value: item.id })));
			}
			if (categoriesData?.length > 0) {
				setCategories(categoriesData?.map((item) => ({ label: item.name, value: item.id })));
			}
			if (fabricType?.length > 0) {
				setFabricTypes(fabricType?.map((item) => ({ label: item.value, value: item.code })));
			}
		})();
	}, []);

	const handleChange = (value, item, type) => {
		let updatedData = data.map((d) => {
			if (d.uId === item.uId) {
				return { ...d, [type]: value };
			}
			return d;
		});
		setData(updatedData);
	};

	const noBorderStyles = {
		control: (base) => ({
			...base,
			borderColor: 'transparent',
			boxShadow: 'none',
			backgroundColor: 'transparent',
			'&:hover': {
				borderColor: '#e4e7eb',
				backgroundColor: '#fff'
			}
		})
	};

	const renderTableData = () => {
		// const addNewRow = () => {
		// 	const uId = _getKey();
		// 	setData((prev) => [...prev, { uId: uId, markets: [], categories: [], fabricTypes: [] }]);
		// 	setEditableId(uId);
		// };

		const removeRow = async (selected) => {
			if (selected?.id) {
				dispatch(openLoader());
				await removeMarketFabricCategoryByClientId({ clientId, mapId: selected.id });
				let filteredData = data.filter((item) => item.id !== selected.id);
				if (filteredData.length === 0) {
					filteredData = [{ uId: _getKey(), markets: [], categories: [], fabricTypes: [] }];
				}
				setData(filteredData);
				dispatch(closeLoader());
			} else {
				const updatedData = data.filter((item) => item.uId !== selected.uId);
				setData(updatedData);
			}
		};

		return data?.map((item, idx) => {
			return (
				<tr
					key={`department-${item.uId}`}
					className={editableId === item.uId ? 'active' : ''}
					onClick={() => setEditableId(item.uId)}
				>
					<td className="market-column">
						<Select
							className="no-shadow-react-select"
							value={item?.markets || {}}
							onChange={(value) => handleChange(value, item, 'markets')}
							options={markets}
							isDisabled={editableId !== item.uId}
							styles={noBorderStyles}
						/>
					</td>
					<td className="fabric-column">
						<Select
							className="no-shadow-react-select"
							value={item?.fabricTypes || {}}
							onChange={(value) => handleChange(value, item, 'fabricTypes')}
							options={fabricTypes}
							isDisabled={editableId !== item.uId}
							styles={noBorderStyles}
						/>
					</td>
					<td className="category-column">
						<Select
							className="no-shadow-react-select"
							value={item?.categories || []}
							onChange={(value) => handleChange(value, item, 'categories')}
							options={categories}
							isMulti
							isDisabled={editableId !== item.uId}
							styles={noBorderStyles}
						/>
					</td>
					<td className="action-column position-relative">
						<div className="option">
							<div className="dropdown">
								<button
									className="btn btn-default dropdown-toggle"
									type="button"
									id="menu1"
									data-toggle="dropdown"
									aria-expanded="false"
								>
									<CommonImage src="/icons/more_icon.svg" alt="" />
								</button>
								<ul
									className="dropdown-menu dropdown-menu-right shadow-lg"
									role="menu"
									aria-labelledby="menu1"
									x-placement="bottom-end"
								>
									<li
										role="presentation"
										className="px-4 pb-3"
										onClick={() => removeRow(item)}
									>
										<a
											role="menuitem"
											tabIndex={-1}
											className="font-weight-normal  text-black"
										>
											Delete
										</a>
									</li>
								</ul>
							</div>
						</div>
						<div className="action-btn d-flex align-items-center gap-2 position-absolute top-0 right-0">
							{/*{data.length === idx + 1 && (*/}
							{/*	<CommonImage*/}
							{/*		src="/icons/plus_dark_32.svg"*/}
							{/*		width={20}*/}
							{/*		height={20}*/}
							{/*		alt="edit"*/}
							{/*		className="cursor-pointer"*/}
							{/*		onClick={addNewRow}*/}
							{/*	/>*/}
							{/*)}*/}
							{idx > 0 && (
								<CommonImage
									src="/icons/minus_dark_32.svg"
									width={20}
									height={20}
									alt="edit"
									className="cursor-pointer"
									onClick={() => removeRow(item)}
								/>
							)}
						</div>
					</td>
				</tr>
			);
		});
	};

	const handleSubmit = async () => {
		try {
			dispatch(openLoader());
			let requestBody = [];
			data.forEach((item) => {
				let obj = {};
				if (item?.markets?.value) {
					obj.productGroupId = parseInt(item.markets.value);
				}
				if (item?.fabricTypes?.value) {
					obj.fabricType = item.fabricTypes.value;
				}
				if (item?.categories?.length > 0) {
					obj.categoryIdList = item.categories?.map((category) => parseInt(category.value));
				}
				requestBody.push(obj);
			});
			await assignMarketFabricCategoryByClientId({ clientId, requestBody });
			onClose();
		} finally {
			dispatch(closeLoader());
		}
	};

	return (
		<ModalContainer onCloseModal={onClose}>
			<div className="popup-wrapper">
				<div className="common-popup create-department-popup">
					<ModalHeader title="Create department" onClose={onClose} />
					<div className="common-popup-body scroll-y-label">
						<div className="create-department-table">
							<table className="table height-sm hover with-border">
								<thead>
									<tr>
										<th>Market</th>
										<th>Fabric</th>
										<th>Category</th>
										<th>Action</th>
									</tr>
								</thead>
								<tbody>{renderTableData()}</tbody>
							</table>
						</div>
					</div>
					<div className="modal-footer">
						<div className="footer-buttons text-right">
							<button className="button outline size32 ml-2" onClick={onClose}>
								Cancel
							</button>
							<button className="button size32 ml-2" onClick={handleSubmit}>
								Submit
							</button>
						</div>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default ClientWiseDepartment;
